import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

// supabase-js finishes the PKCE exchange via detectSessionInUrl; we just wait for
// the session to resolve, then hand off to the app (RequireAuth shows the
// pending/error state if provisioning failed).
export function AuthCallbackPage() {
  const { access } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (access === 'signed_out') navigate('/login', { replace: true });
    else if (access !== 'loading') navigate('/inbox', { replace: true });
  }, [access, navigate]);

  return <div className="center-screen"><div className="spinner" /></div>;
}
